{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Whatsapp šabloni",
      "SUBTITLE": "Izaberite koji whatsapp šablon želite da pošaljete",
      "TEMPLATE_SELECTED_SUBTITLE": "Configure template: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Pretraži šablone",
      "NO_TEMPLATES_FOUND": "Nijedan šablon nije pronađen",
      "HEADER": "Header",
      "BODY": "Body",
      "FOOTER": "Footer",
      "BUTTONS": "Buttons",
      "CATEGORY": "Kategorija",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_CONTENT_FALLBACK": "media content",
      "NO_TEMPLATES_AVAILABLE": "No WhatsApp templates available. Click refresh to sync templates from WhatsApp.",
      "REFRESH_BUTTON": "Refresh templates",
      "REFRESH_SUCCESS": "Templates refresh initiated. It may take a couple of minutes to update.",
      "REFRESH_ERROR": "Failed to refresh templates. Please try again.",
      "LABELS": {
        "LANGUAGE": "Jezik",
        "TEMPLATE_BODY": "Telo šablona",
        "CATEGORY": "Kategorija"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Promenljive",
      "LANGUAGE": "Jezik",
      "CATEGORY": "Kategorija",
      "VARIABLE_PLACEHOLDER": "Unesite vrednost za {variable}",
      "GO_BACK_LABEL": "Povratak",
      "SEND_MESSAGE_LABEL": "Pošalji poruku",
      "FORM_ERROR_MESSAGE": "Molim vas popunite sve promenljive pre slanja",
      "MEDIA_HEADER_LABEL": "{type} Header",
      "OTP_CODE": "Enter 4-8 digit OTP",
      "EXPIRY_MINUTES": "Enter expiry minutes",
      "BUTTON_PARAMETERS": "Button Parameters",
      "BUTTON_LABEL": "Button {index}",
      "COUPON_CODE": "Enter coupon code (max 15 chars)",
      "MEDIA_URL_LABEL": "Enter {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "Enter document filename (e.g., Invoice_2025.pdf)",
      "BUTTON_PARAMETER": "Enter button parameter"
    }
  }
}
